var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Taxonomies", path: { name: "admin-taxonomies" } }],
          name: "Category Types",
          "no-title": "",
        },
      }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: { title: "Category Types" },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c(
                            "no-permission-wrapper",
                            { attrs: { show: !_vm.canCreateTaxonomies } },
                            [
                              _c(
                                "b-btn",
                                {
                                  attrs: {
                                    variant: "success",
                                    disabled: !_vm.canCreateTaxonomies,
                                  },
                                  on: { click: _vm.openNewModal },
                                },
                                [_vm._v("Add new Category Type")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("b-table", {
                    attrs: {
                      fields: _vm.table_fields,
                      items: _vm.categoryTypes,
                      "table-class": "text-nowrap",
                      responsive: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(name)",
                        fn: function (data) {
                          return [
                            _c("h4", { staticClass: "mb-0" }, [
                              _vm._v(_vm._s(data.item.name)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell(productionMethod)",
                        fn: function (data) {
                          return [
                            data.item.is_grow
                              ? _c(
                                  "b-badge",
                                  { attrs: { variant: "success" } },
                                  [_vm._v("Grow")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            data.item.is_manufacture
                              ? _c(
                                  "b-badge",
                                  { attrs: { variant: "secondary" } },
                                  [_vm._v("Manufacture")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (data) {
                          return [
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canUpdateTaxonomies } },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: {
                                      variant: "primary",
                                      disabled: !_vm.canUpdateTaxonomies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openEditModal(data.item)
                                      },
                                    },
                                  },
                                  [_vm._v("Edit")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canDeleteTaxonomies } },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: {
                                      variant: "danger",
                                      disabled: !_vm.canDeleteTaxonomies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.confirmDelete(data.item)
                                      },
                                    },
                                  },
                                  [_vm._v("Delete")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(order)",
                        fn: function (data) {
                          return [
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canUpdateTaxonomies } },
                              [
                                data.index > 0
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          disabled: !_vm.canUpdateTaxonomies,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeOrder(
                                              data.index,
                                              data.index - 1
                                            )
                                          },
                                        },
                                      },
                                      [_c("b-icon-arrow-up")],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                data.index < _vm.categoryTypes.length - 1
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          disabled: !_vm.canUpdateTaxonomies,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeOrder(
                                              data.index,
                                              data.index + 1
                                            )
                                          },
                                        },
                                      },
                                      [_c("b-icon-arrow-down")],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.edit_category_type
        ? _c("admin-category-type-edit-modal", {
            attrs: { "category-type": _vm.edit_category_type, visible: "" },
            on: {
              cancel: function ($event) {
                _vm.edit_category_type = null
              },
              success: _vm.onCategoryTypeEdited,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("admin-category-type-add-modal", {
        ref: "newModal",
        on: { success: _vm.onCategoryTypeAdded },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }